import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiBody, ApiTags } from '@nestjs/swagger';
import { ApplyForLeavesDTO } from './dto/apply-for-leaves.dto';
import { ApplyForLeavesService } from './apply-for-leaves.service';
import { AllApplyForLeavesResponse, ApplyForLeavesResponseModel, ApplyForLeavesResponseModels, ApplyForOdCoResponseModel, ApplyOdCoFilter, GetAllAvailableLeavesResponseModel } from '@gtpl/shared-models/hrms';
import { ApplyForLeavesRequest } from './dto/apply-for-leaves.request';
import { GetAllAvailableLeavesDto } from './dto/get-available-leaves.dto';

@Controller('apply-for-leaves')
@ApiTags('apply-for-leaves')
export class ApplyForLeavesController {
    constructor(
        private service: ApplyForLeavesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }


    @Post('/createManualLeave')
    async createManualLeave(@Body() dto: ApplyForLeavesDTO): Promise<ApplyForLeavesResponseModels> {
        try {
            return await this.service.createManualLeave(dto, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ApplyForLeavesResponseModels, error);
        }
    }

    @Post('/createLeave')
    @ApiBody({type:ApplyForLeavesDTO})
    async createLeave(@Body() data:any): Promise<any>{
       try{
        return this.service.createLeave(data);
       } catch(err){
        return this.applicationExceptionHandler.returnException(ApplyForLeavesResponseModel,err);
       }
    }

    // @Post('/updateLeave')
    // async updateLeave(@Body() dto: ApplyForLeavesDTO): Promise<ApplyForLeavesResponseModel> {
    //     try {
    //         return await this.service.createLeave(dto, true);
    //     } catch (error) {
    //         return this.applicationExceptionHandler.returnException(ApplyForLeavesResponseModel, error);
    //     }
    // }

    @Post('/getAllAppliedLeaves')
    async getAllAppliedLeaves(): Promise<AllApplyForLeavesResponse> {
        try {

            return await this.service.getAllAppliedLeaves();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllApplyForLeavesResponse, error);
        }
    }

    @Post('activateOrDeactivateApplyForLeave')
    async activateOrDeactivateApplyForLeave(@Body() req: ApplyForLeavesRequest): Promise<ApplyForLeavesResponseModel> {
        try {
            return await this.service.activateOrDeactivateApplyForLeave(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ApplyForLeavesResponseModel, error);
        }
    }

    @Post('updateLeaveStatus')
    async updateLeaveStatus(@Body() req: ApplyForLeavesRequest): Promise<ApplyForLeavesResponseModel> {
        try {
            return await this.service.updateLeaveStatus(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ApplyForLeavesResponseModel, error);
        }
    }

    @Post('/createOdCo')
    @ApiBody({type:ApplyForLeavesDTO})
    async createOdCo(@Body() data:any): Promise<any>{
       try{
        return this.service.createOdCo(data);
       } catch(err){
        return this.applicationExceptionHandler.returnException(ApplyForLeavesResponseModel,err);
       }
    }

    @Post('/getCoOd')
    async getCoOd(@Body() typeReq:ApplyOdCoFilter): Promise<ApplyForOdCoResponseModel> {
        try {
            return this.service.getCoOd(typeReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(ApplyForOdCoResponseModel, err);

        }
    }




}
